import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { WithUser, withUser } from '../HOC/User';
import { withToast, WithToast } from '../HOC/Toast';
import KDInput from '../Input/Input';
import { Button, Theme, createStyles, withStyles, WithStyles, CircularProgress, List, ListItem, ListItemText } from '@material-ui/core';
import strings from 'src/strings';
import { UsersAPI } from 'src/api';
import { Address } from 'src/api/endpoints/user';

interface _AddressFormProps {
    onNext: () => void
    onCancel?: () => void
    hideHeader?: boolean;
    nextButtonText?: string;
    className?: string
}
interface AddressFormProps extends WithUser, WithToast, WithStyles<typeof styles>, _AddressFormProps {

}

interface AddressFormState {
    first_name: string;
    last_name: string;
    address_line1: string;
    address_line2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    loading: boolean;
    errors: {
        first_name?: boolean,
        last_name?: boolean,
        address?: boolean,
        city?: boolean,
        zip?: boolean,
        country?: boolean
    },
    existing_addresses: Address[]
    selected_address?: string;
}

class AddressForm extends React.Component<AddressFormProps, AddressFormState> {

    constructor(props: AddressFormProps) {
        super(props)
        this.state = {
            loading: false,
            errors: {
            },
            first_name: this.props.user ? this.props.user.full_name.split(' ')[0] : '',
            last_name: this.props.user ? this.props.user.full_name.split(' ').slice(1).join(' ') : '',
            address_line1: '',
            address_line2: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            existing_addresses: []
        }
    }

    componentDidMount() {
        this.setState({ loading: true })
        UsersAPI.getAddresses().then(addresses => {
            this.setState({ existing_addresses: addresses, loading: false }, () => {
                if (addresses.length > 0) {
                    this.selectAddresss(addresses[0])
                }
            })
        }).catch(() => {
            this.setState({ loading: false })
        })
    }

    private submit() {
        const { first_name, last_name, city, country, zip, address_line1, address_line2 } = this.state
        if (!first_name) {
            this.props.showToast('error', strings.error_invalidFirstName)
            this.setState({ errors: { first_name: true } })
        } else if (!last_name) {
            this.props.showToast('error', strings.error_invalidLastName)
            this.setState({ errors: { last_name: true } })
        } else if (!address_line1) {
            this.props.showToast('error', strings.error_invalidAddress)
            this.setState({ errors: { address: true } })
        } else if (!city) {
            this.props.showToast('error', strings.error_invalidCity)
            this.setState({ errors: { city: true } })
        } else if (!country) {
            this.props.showToast('error', strings.error_invalidCountry)
            this.setState({ errors: { country: true } })
        } else if (!zip) {
            this.props.showToast('error', strings.error_invalidZip)
            this.setState({ errors: { zip: true } })
        } else {
            this.setState({ errors: {}, loading: true })
            UsersAPI.addAddress({
                first_name,
                last_name,
                city,
                country,
                zip,
                address_line1,
                address_line2
            }).then(address => {
                this.setState({ errors: {}, loading: false, existing_addresses: this.state.existing_addresses.concat(address), selected_address: address.id })
                this.props.onNext()
            }).catch(err => {
                this.props.showToast('error', strings.error_generic)
                this.setState({ errors: {}, loading: false })
            })
        }
    }

    private selectAddresss(address: Address) {
        this.setState({
            first_name: address.first_name,
            last_name: address.last_name,
            address_line1: address.address_line1,
            address_line2: address.address_line2 || '',
            city: address.city,
            state: address.state || '',
            zip: address.zip,
            country: address.country,
            selected_address: address.id
        })
    }

    public render() {
        return (
            <React.Fragment>
                {this.props.hideHeader !== true && <Typography variant="h6" gutterBottom>
                    {strings.checkout_billingAddress}
                </Typography>}
                <div className={this.props.className}>
                    <List className={this.props.classes.list}>
                        {this.state.existing_addresses.map((address, i) => {
                            return <ListItem button key={i} selected={this.state.selected_address == address.id} onClick={(e) => this.selectAddresss(address)}>
                                <ListItemText
                                    primary={address.first_name + ' ' + address.last_name}
                                    secondary={
                                        <React.Fragment>
                                            {address.address_line1}<br />
                                            {address.address_line2}{address.address_line2 && <br />}
                                            {address.state ? address.state + ',' : ''} {address.city}, {address.country}
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                        })}
                    </List>
                    <Grid container spacing={10}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                id="firstName"
                                error={this.state.errors.first_name}
                                name="firstName"
                                label={strings.address_firstName}
                                fullWidth
                                autoComplete="fname"
                                value={this.state.first_name}
                                onChange={(e) => this.setState({ first_name: e.target.value, selected_address: undefined })} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                error={this.state.errors.last_name}
                                id="lastName"
                                name="lastName"
                                label={strings.address_lastName}
                                fullWidth
                                autoComplete="lname"
                                value={this.state.last_name}
                                onChange={(e) => this.setState({ last_name: e.target.value, selected_address: undefined })} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                error={this.state.errors.address}
                                id="address1"
                                name="address1"
                                label={strings.address_line1}
                                fullWidth
                                autoComplete="billing address-line1"
                                value={this.state.address_line1}
                                onChange={(e) => this.setState({ address_line1: e.target.value, selected_address: undefined })} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="addiress2"
                                name="addiress2"
                                label={strings.address_line2}
                                fullWidth
                                autoComplete="billing address-line2"
                                value={this.state.address_line2}
                                onChange={(e) => this.setState({ address_line2: e.target.value, selected_address: undefined })} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                error={this.state.errors.city}
                                id="city"
                                name="city"
                                label={strings.address_city}
                                fullWidth
                                autoComplete="billing address-level2"
                                value={this.state.city}
                                onChange={(e) => this.setState({ city: e.target.value, selected_address: undefined })} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField id="state" name="state" label="State/Province/Region" fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                id="zip"
                                error={this.state.errors.zip}
                                name="zip"
                                label={strings.address_zip}
                                fullWidth
                                autoComplete="billing postal-code"
                                value={this.state.zip}
                                onChange={(e) => this.setState({ zip: e.target.value, selected_address: undefined })} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                id="country"
                                error={this.state.errors.country}
                                name="country"
                                label={strings.address_country}
                                fullWidth
                                autoComplete="billing country"
                                value={this.state.country}
                                onChange={(e) => this.setState({ country: e.target.value, selected_address: undefined })} />
                        </Grid>
                    </Grid>
                    <div className={this.props.classes.buttons}>
                        {this.props.onCancel && <Button
                            variant='outlined'
                            color="secondary"
                            onClick={this.props.onCancel.bind(this)}
                            disabled={this.state.loading}
                            className={this.props.classes.button + ' ' + this.props.classes.cancel_button}>
                            {strings.cancel}
                        </Button>}
                        {this.state.loading && <CircularProgress size={30} className={this.props.classes.button} />}
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.submit.bind(this)}
                            disabled={this.state.loading}
                            className={this.props.classes.button}>
                            {this.props.nextButtonText || strings.checkout_next}
                        </Button>
                    </div>
                </div>
            </React.Fragment >
        )
    }
}
const styles = (theme: Theme) => createStyles({
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(),
    },
    cancel_button: {
        marginLeft: 0,
        marginRight: 'auto'
    },
    inline: {
        display: 'inline',
    },
    list: {
        paddingTop: 0,
        maxHeight: 200,
        position: 'relative',
        overflow: 'scroll',
    }
})
export default withStyles(styles)(withToast(withUser(AddressForm))) as React.ComponentClass<_AddressFormProps> // ToDo: Exlcude not working here


// WEBPACK FOOTER //
// ./src/components/Checkout/AddressForm.tsx